/* eslint-disable react/prop-types */
import React, { useState, useCallback, memo } from 'react';

interface DarkModeToggleProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
  includeLabel?: boolean;
  style?: React.CSSProperties;
}

export const DarkModeToggle: React.FC<DarkModeToggleProps> = memo(({
  darkMode,
  toggleDarkMode,
  includeLabel = true,
  style = {}
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDarkMode();
      }
    },
    [toggleDarkMode]
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ...style }}>
      {includeLabel && (
        <span
          id="dark-mode-label"
          style={{ color: '#fff', fontSize: '13px' }}
        >
          Dark
        </span>
      )}
      <button
        onClick={toggleDarkMode}
        onKeyDown={handleKeyDown}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        role="switch"
        aria-checked={darkMode}
        aria-labelledby={includeLabel ? 'dark-mode-label' : undefined}
        aria-label={includeLabel ? undefined : `Dark mode ${darkMode ? 'on' : 'off'}`}
        style={{
          width: '40px',
          height: '22px',
          background: darkMode ? '#2563eb' : '#475569',
          borderRadius: '11px',
          position: 'relative',
          cursor: 'pointer',
          transition: 'background 0.3s ease, transform 0.2s ease',
          boxShadow: darkMode ? '0 0 8px rgba(37,99,235,0.4)' : '0 0 4px rgba(0,0,0,0.2)',
          border: 'none',
          padding: 0,
          transform: isHovered ? 'scale(1.05)' : 'scale(1)',
        }}
      >
        <div
          style={{
            width: '18px',
            height: '18px',
            background: '#fff',
            borderRadius: '50%',
            position: 'absolute',
            top: '2px',
            left: darkMode ? '20px' : '2px',
            transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s ease',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            transform: isHovered ? 'scale(1.1)' : 'scale(1)',
          }}
          aria-hidden="true"
        />
      </button>
    </div>
  );
});

DarkModeToggle.displayName = 'DarkModeToggle';
